import { sumBy } from "lodash";
import React from "react";
import { useMutation } from "react-query";
import { Gratuity } from "types";
import { api } from "../../../api/api";
import { useSeller } from "../../../hooks/useAccount";
import { Currency } from "../../Common/Currency";
import { PromptModal } from "../../Common/PromptModal";

interface ReconcileGratuitiesModalProps {
    isOpen: boolean;
    onClose: () => void;
    selectedGratuities: Gratuity[];
}

export const ReconcileGratuitiesModal = ({ isOpen, onClose, selectedGratuities }: ReconcileGratuitiesModalProps) => {
    const seller = useSeller();
    const { mutateAsync: reconcileGratuities, isLoading } = useMutation(async () => {
        const transactions = selectedGratuities.map((gratuity) => ({ id: gratuity.transaction.id }));

        return api.post(`/transactions`, {
            type: "gratuity_reconcile",
            transactions,
            seller: { id: seller.id },
        });
    });

    const amount = sumBy(selectedGratuities, "transaction.items[0].net");

    const handleReconcileGratuities = async () => {
        await reconcileGratuities();
        onClose();
    };

    return (
        <PromptModal
            title="Reconcile Gratuity"
            isOpen={isOpen}
            isLoading={isLoading}
            onClose={onClose}
            onConfirm={handleReconcileGratuities}
        >
            <span>You are reconciling a total of </span>
            <Currency>{amount}</Currency>
            <span> in gratuities. These gratuity transactions will be marked as paid out.</span>
        </PromptModal>
    );
};
